import type { LucideIcon } from 'lucide-react';
import { TrendingUp, CalendarCheck, Flame } from 'lucide-react';

function Stat({ icon: Icon, tileBg, iconColor, value, label }: {
  icon: LucideIcon; tileBg: string; iconColor: string; value: string; label: string;
}) {
  return (
    <div className="flex flex-col items-center justify-center gap-3 px-2 text-center">
      <span className="flex size-11 items-center justify-center rounded-xl" style={{ backgroundColor: tileBg }}>
        <Icon className="size-5" style={{ color: iconColor }} />
      </span>
      <p className="text-2xl font-bold leading-8 text-[#111827]">{value}</p>
      <p className="text-xs text-[#9ca3af]">{label}</p>
    </div>
  );
}

export function BatchProgressSnapshot({ coursePct, attendancePct, streakDays }: {
  coursePct: number; attendancePct: number; streakDays: number;
}) {
  return (
    <section className="flex flex-col rounded-[20px] border border-[#ececec] bg-white p-[25px] shadow-[0px_1px_1.5px_rgba(0,0,0,0.1),0px_1px_1px_rgba(0,0,0,0.1)]" aria-label="Progress snapshot">
      <h3 className="text-sm font-bold text-[#111827]">Progress Snapshot</h3>
      <div className="grid grid-cols-3 divide-x divide-[#ececec] pt-6">
        <Stat icon={TrendingUp} tileBg="#fff5f0" iconColor="#ff5a1f" value={`${coursePct}%`} label="Overall Progress" />
        <Stat icon={CalendarCheck} tileBg="#f5f3ff" iconColor="#8b5cf6" value={`${attendancePct}%`} label="Attendance" />
        <Stat icon={Flame} tileBg="#f5f3ff" iconColor="#8b5cf6" value={`${streakDays}`} label="Day Streak" />
      </div>
    </section>
  );
}
